import rfStore from "./rfStore";

/**
 * 事件IDS
 * https://rockflow.feishu.cn/docx/LnNIdJkmVoGbThxrYcScW8Ognsb
 *
 * 事件规范：[页面]_[元素]_[动作]
 *   - 示例：
    - home_banner_click（首页Banner点击）
    - product_detail_pv（商品详情页曝光）
    - search_result_scroll（搜索结果页滚动）

		- 神策除了key之外还有一个description，用事件的命名规范，可以写中文
  - 示例
    - 首页_Banner_点击
 */

export enum SensorsEventIds {
	// 选择证件类型
	AO_UPLOADIDPROOF_VIEW = "ao_uploadidproof_view",
	AO_UPLOADIDPROOF_NEXTPAGE = "ao_uploadidproof_nextpage",
	AO_UPLOADIDPROOF_PRAVICY = "ao_uploadidproof_pravicy",
	AO_UPLOADIDPROOF_ONFFIDO = "ao_uploadidproof_onfido",

	// 是否为国籍纳税剧名
	AO_TAX_RESIDENT_VIEW = "ao_tax_resident_view",
	AO_TAX_RESIDENT_NEXTPAGE = "ao_tax_resident_nextpage",

	// 上传护照
	AO_UPLOADPASSPORT1_VIEW = "ao_uploadpassport1_view", // 上传护照页1
	AO_UPLOADPASSPORT1_NEXTPAGE = "ao_uploadpassport1_nextpage",
	AO_UPLOADPASSPORT1_PRAVICY = "ao_uploadpassport1_pravicy", // 隐私协议
	AO_UPLOADPASSPORT1_ONFFIDO = "ao_uploadpassport1_onfido", // onfido
	AO_UPLOADPASSPORT2_VIEW = "ao_uploadpassport2_view", // 上传护照页2
	AO_UPLOADPASSPORT2_NEXTPAGE = "ao_uploadpassport2_nextpage",
	AO_UPLOADPASSPORT2_PRAVICY = "ao_uploadpassport2_pravicy",
	AO_UPLOADPASSPORT2_ONFFIDO = "ao_uploadpassport2_onfido",
	AO_UPLOADPASSPORT3_VIEW = "ao_uploadpassport3_view",
	AO_UPLOADPASSPORT3_NEXTPAGE = "ao_uploadpassport3_nextpage",
	AO_UPLOADPASSPORT3_PRAVICY = "ao_uploadpassport3_pravicy",
	AO_UPLOADPASSPORT3_ONFFIDO = "ao_uploadpassport3_onfido",

	// 上传身份证
	AO_UPLOADIDCARD1_VIEW = "ao_uploadidcard1_view", // 上传身份证页1
	AO_UPLOADIDCARD1_NEXTPAGE = "ao_uploadidcard1_nextpage",
	AO_UPLOADIDCARD1_PRAVICY = "ao_uploadidcard1_pravicy",
	AO_UPLOADIDCARD1_ONFFIDO = "ao_uploadidcard1_onfido",
	AO_UPLOADIDCARD2_VIEW = "ao_uploadidcard2_view", // 上传身份证页2
	AO_UPLOADIDCARD2_NEXTPAGE = "ao_uploadidcard2_nextpage",
	AO_UPLOADIDCARD2_PRAVICY = "ao_uploadidcard2_pravicy",
	AO_UPLOADIDCARD2_ONFFIDO = "ao_uploadidcard2_onfido",
	AO_UPLOADIDCARD3_VIEW = "ao_uploadidcard3_view", // 上传身份证页3
	AO_UPLOADIDCARD3_NEXTPAGE = "ao_uploadidcard3_nextpage",
	AO_UPLOADIDCARD3_PRAVICY = "ao_uploadidcard3_pravicy",
	AO_UPLOADIDCARD3_ONFFIDO = "ao_uploadidcard3_onfido",
	AO_UPLOADIDCARD3_SHARPNESS_FAIL = "ao_uploadidcard3_sharpness_fail",

	// 上传外籍身份证/居留卡
	AO_UPLOADALIEN1_VIEW = "ao_uploadalien1_view",
	AO_UPLOADALIEN1_NEXTPAGE = "ao_uploadalien1_nextpage",
	AO_UPLOADALIEN1_PRAVICY = "ao_uploadalien1_pravicy",
	AO_UPLOADALIEN1_ONFFIDO = "ao_uploadalien1_onfido",
	AO_UPLOADALIEN2_VIEW = "ao_uploadalien2_view",
	AO_UPLOADALIEN2_NEXTPAGE = "ao_uploadalien2_nextpage",
	AO_UPLOADALIEN2_PRAVICY = "ao_uploadalien2_pravicy",
	AO_UPLOADALIEN2_ONFFIDO = "ao_uploadalien2_onfido",
	AO_UPLOADALIEN3_VIEW = "ao_uploadalien3_view",
	AO_UPLOADALIEN3_NEXTPAGE = "ao_uploadalien3_nextpage",
	AO_UPLOADALIEN3_PRAVICY = "ao_uploadalien3_pravicy",
	AO_UPLOADALIEN3_ONFFIDO = "ao_uploadalien3_onfido",

	// 填写姓名页
	AO_NAME_VIEW = "ao_name_view",
	AO_NAME_FIRSTNAME = "ao_name_firstname",
	AO_NAME_MIDDLENAME = "ao_name_middlename",
	AO_NAME_LASTNAME = "ao_name_lastname",
	AO_NAME_NEXTPAGE = "ao_name_nextpage",
	AO_NAME_PRAVICY = "ao_name_pravicy",
	AO_NAME_SECURITY = "ao_name_security",
	// 填写性别页
	AO_GENDER_VIEW = "ao_gender_view",
	AO_GENDER_MALE = "ao_gender_male",
	AO_GENDER_FEMALE = "ao_gender_female",
	AO_GENDER_OTHER = "ao_gender_other",
	AO_GENDER_NEXTPAGE = "ao_gender_nextpage",
	AO_GENDER_PRAVICY = "ao_gender_pravicy",
	AO_GENDER_SECURITY = "ao_gender_security",
	// 填写国籍页
	AO_BIRTHDAY_VIEW = "ao_birthday_view",
	AO_BIRTHDAY_BIRTHDAY = "ao_birthday_birthday",
	AO_BIRTHDAY_NEXTPAGE = "ao_birthday_nextpage",
	AO_BIRTHDAY_PRAVICY = "ao_birthday_pravicy",
	AO_BIRTHDAY_SECURITY = "ao_birthday_security",
	// 国家
	AO_NATIONALITY_VIEW = "ao_nationality_view",
	AO_NATIONALITY_NATIONALITY = "ao_nationality_nationality",
	AO_NATIONALITY_NEXTPAGE = "ao_nationality_nextpage",
	AO_NATIONALITY_PRAVICY = "ao_nationality_pravicy",
	AO_NATIONALITY_SECURITY = "ao_nationality_security",
	AO_NATIONALITY_MAINLAND_BLOCKED_VIEW = "ao_nationality_mainland_blocked_view", // 开户国籍页_大陆用户拦截弹窗_曝光
	AO_NATIONALITY_MAINLAND_BLOCKED_CONFIRM = "ao_nationality_mainland_blocked_confirm", // 开户国籍页_大陆用户拦截弹窗_确认
	// 纳税国家
	AO_TAX_RESIDENT_NATIONALITY_VIEW = "ao_tax_resident_nationality_view",
	AO_TAX_RESIDENT_NATIONALITY_NEXTPAGE = "ao_tax_resident_nationality_nextpage",
	AO_TAX_RESIDENT_NATIONALITY_PRAVICY = "ao_tax_resident_nationality_pravicy",
	AO_TAX_RESIDENT_NATIONALITY_SECURITY = "ao_tax_resident_nationality_security",
	// 填写证件号码页
	AO_IDNUMBER_VIEW = "ao_idnumber_view",
	AO_IDNUMBER_INPIDNUMBER = "ao_idnumber_inpidnumber",
	AO_IDNUMBER_INPPASSPORTNUMBER = "ao_idnumber_inppassportnumber",
	AO_IDNUMBER_NEXTPAGE = "ao_idnumber_nextpage",
	AO_IDNUMBER_PRAVICY = "ao_idnumber_pravicy",
	AO_IDNUMBER_SECURITY = "ao_idnumber_security",
	/// 证件号重复
	AO_IDNUMBER_DUPLICATE = "ao_idnumber_duplicate",
	// 填写居住地址页
	AO_RESIDENTIALADRESS_VIEW = "ao_residentialadress_view",
	AO_RESIDENTIALADRESS_INPNATION = "ao_residentialadress_inpnation",
	AO_RESIDENTIALADRESS_INPPROVINCE = "ao_residentialadress_inpprovince",
	AO_RESIDENTIALADRESS_INPADRESS = "ao_residentialadress_inpadress",
	AO_RESIDENTIALADRESS_NEXTPAGE = "ao_residentialadress_nextpage",
	AO_RESIDENTIALADRESS_PRAVICY = "ao_residentialadress_pravicy",
	AO_RESIDENTIALADRESS_SECURITY = "ao_residentialadress_security",
	// 确认协议页
	AO_AGREEMENTS_VIEW = "ao_agreements_view",
	AO_AGREEMENTS_CONFIRMANDAGREE = "ao_agreements_confirmandagree",
	AO_AGREEMENTS_MAINLAND_BLOCKED_VIEW = "ao_agreements_mainland_blocked_view", // 开户协议页_大陆用户拦截弹窗_曝光
	AO_AGREEMENTS_MAINLAND_BLOCKED_CONFIRM = "ao_agreements_mainland_blocked_confirm", // 开户协议页_大陆用户拦截弹窗_确认
	// 绑定开户手机号||邮箱
	BAO_LINKPHONE_VIEW = "bao_linkphone_view",
	BAO_LINKPHONE_CHANGEAREACODE = "bao_linkphone_changeareacode",
	BAO_LINKPHONE_SELECTAREACODE = "bao_linkphone_selectareacode",
	BAO_LINKPHONE_INPPHONE = "bao_linkphone_inpphone",
	BAO_LINKPHONE_NEXTPAGE = "bao_linkphone_nextpage",
	BAO_PHONEVERIFICATION_VIEW = "bao_phoneverification_view",
	BAO_PHONEVERIFICATION_INPVERCODE = "bao_phoneverification_inpvercode",
	BAO_PHONEVERIFICATION_RESEND = "bao_phoneverification_resend",
	BAO_PHONEVERIFICATION_NEXTPAGE = "bao_phoneverification_nextpage",
	BAO_LINKEMAIL_VIEW = "bao_linkemail_view",
	BAO_LINKEMAIL_INPEMAIL = "bao_linkemail_inpemail",
	BAO_LINKEMAIL_NEXTPAGE = "bao_linkemail_nextpage",
	BAO_EMAILVERIFICATION_VIEW = "bao_emailverification_view",
	BAO_EMAILVERIFICATION_INPVERCODE = "bao_emailverification_inpvercode",
	BAO_EMAILVERIFICATION_RESEND = "bao_emailverification_resend",
	BAO_EMAILVERIFICATION_NEXTPAGE = "bao_emailverification_nextpage",
	// 填写税务识别号
	BAO_TAXID_VIEW = "bao_taxid_view",
	BAO_TAXID_ADDTAXNUMBER = "bao_taxid_addtaxnumber",
	BAO_TAXID_TAXCOUNTRY = "bao_taxid_taxcountry",
	BAO_TAXID_TAXNUMBER = "bao_taxid_taxnumber",
	BAO_TAXID_NEXTPAGE = "bao_taxid_nextpage",
	BAO_TAXID_PRAVICY = "bao_taxid_pravicy",
	BAO_TAXID_SECURITY = "bao_taxid_security",
	// 填写职业信息
	BAO_WORKSTATUS_VIEW = "bao_workstatus_view",
	BAO_WORKSTATUS_EMPLOYED = "bao_workstatus_employed", // 在职员工
	BAO_WORKSTATUS_ENTREPRENEUR = "bao_workstatus_entrepreneur", // 公司老板
	BAO_WORKSTATUS_STUDENT = "bao_workstatus_student", // 学生
	BAO_WORKSTATUS_HOUSEWIFE = "bao_workstatus_housewife", // 家庭煮夫/妇
	BAO_WORKSTATUS_RETIRED = "bao_workstatus_retired", // 退休
	BAO_WORKSTATUS_FULLTIMETRADER = "bao_workstatus_fulltimetrader", // 全职交易者
	BAO_WORKSTATUS_FREELANCER = "bao_workstatus_freelancer", // 自由职业者
	BAO_WORKSTATUS_NEXTPAGE = "bao_workstatus_nextpage",
	BAO_WORKSTATUS_PRAVICY = "bao_workstatus_pravicy",
	BAO_WORKSTATUS_SECURITY = "bao_workstatus_security",
	// 填写工作情况页
	BAO_WORKDETAILS_VIEW = "bao_workdetails_view",
	BAO_WORKDETAILS_COMPANYNAME = "bao_workdetails_companyname", // 公司名称
	BAO_WORKDETAILS_POSITION = "bao_workdetails_position", // 职位
	BAO_WORKDETAILS_NOTINPCOMPANY = "bao_workdetails_notinpcompany", // 本人/家人不是上市公司高管
	BAO_WORKDETAILS_NOTINPBROKER = "bao_workdetails_notinpbroker", // 本人/家人未就职于其他券商
	BAO_WORKDETAILS_INPCOMPANY = "bao_workdetails_inpcompany", // 上市公司高管
	BAO_WORKDETAILS_INPBROKER = "bao_workdetails_inpbroker", // 其他券商
	BAO_WORKDETAILS_NEXTPAGE = "bao_workdetails_nextpage",
	BAO_WORKDETAILS_PRAVICY = "bao_workdetails_pravicy",
	BAO_WORKDETAILS_SECURITY = "bao_workdetails_security",
	// 填写交易经验页
	BAO_EXPERIENCE_VIEW = "bao_experience_view",
	BAO_EXPERIENCE_NONE = "bao_experience_none", // 从来没有交易过
	BAO_EXPERIENCE_SOME = "bao_experience_some", // 有交易过
	BAO_EXPERIENCE_KNOW = "bao_experience_know", // 经常交易
	BAO_EXPERIENCE_EXPERT = "bao_experience_expert", // 交易大神
	BAO_EXPERIENCE_NEXTPAGE = "bao_experience_nextpage",
	BAO_EXPERIENCE_PRAVICY = "bao_experience_pravicy",
	BAO_EXPERIENCE_SECURITY = "bao_experience_security",
	// 填写投资目的页
	BAO_OBJECTIVES_VIEW = "bao_objectives_view",
	BAO_OBJECTIVES_FORTUNE = "bao_objectives_fortune", // 赚大钱
	BAO_OBJECTIVES_SOMEPROFIT = "bao_objectives_someprofit", // 小赚
	BAO_OBJECTIVES_STEADYGROWTH = "bao_objectives_steadygrowth", // 稳健增值
	BAO_OBJECTIVES_HEDGE_RISK = "bao_objectives_hedge_risk", // 对冲风险
	BAO_OBJECTIVES_HAVEFUN = "bao_objectives_havefun", // 享受快乐
	BAO_OBJECTIVES_NEXTPAGE = "bao_objectives_nextpage",
	BAO_OBJECTIVES_PRAVICY = "bao_objectives_pravicy",
	BAO_OBJECTIVES_SECURITY = "bao_objectives_security",
	//
	BAO_INCOMESTATUS_VIEW = "bao_incomestatus_view",
	BAO_INCOMESTATUS_NETASSET = "bao_incomestatus_netasset", // 净资产
	BAO_INCOMESTATUS_NETLIQUIDITYASSET = "bao_incomestatus_netliquidityasset", // 净流动资产
	BAO_INCOMESTATUS_NETYEARLYINCOME = "bao_incomestatus_netyearlyincome", // 净年收入
	BAO_INCOMESTATUS_NEXTPAGE = "bao_incomestatus_nextpage",
	BAO_INCOMESTATUS_PRAVICY = "bao_incomestatus_pravicy",
	BAO_INCOMESTATUS_SECURITY = "bao_incomestatus_security",
	// 海外银行卡
	BAO_OVERSEA_ACC_VIEW = "bao_oversea_acc_view",
	BAO_OVERSEA_ACC_Y = "bao_oversea_acc_y",
	BAO_OVERSEA_ACC_N = "bao_oversea_acc_n",
	// 额外补充居住地址
	BAO_ADDITIONAL_RESIDENTIALADRESS_VIEW = "bao_additional_residentialadress_view",
	BAO_ADDITIONAL_RESIDENTIALADRESS_NEXTPAGE = "bao_additional_residentialadress_nextpage",
	BAO_ADDITIONAL_RESIDENTIALADRESS_PRAVACY_VIEW = "bao_additional_residentialadress_pravacy_view",
	BAO_ADDITIONAL_RESIDENTIALADRESS_PRAVACY_NEXTPAGR = "bao_additional_residentialadress_pravacy_nextpage",

	// 上传居住地址证明页
	UAP_UPLOAD_VIEW = "uap_upload_view",
	UAP_UPLOAD_DOCTYPE = "uap_upload_doctype", // 选择文件类型
	UAP_UPLOAD_CLICKFOREXAMPLES = "uap_upload_clickforexamples", // 点击查看样例
	UAP_UPLOAD_NEXTPAGE = "uap_upload_nextpage",
	UAP_UPLOAD_PRAVICY = "uap_upload_pravicy",
	UAP_UPLOAD_SECURITY = "uap_upload_security",
	// 电汇入金
	WIRETRANSFER_INFO_VIEW = "wiretransfer_info_view",
	WIRETRANSFER_CLICK_EXPLAIN = "wiretransfer_click_explain",
	WIRETRANSFER_CLICK_RECEIPTS = "wiretransfer_click_receipts",
	WIRETRANSFER_SGDINFO_VIEW = "wiretransfer_sgdinfo_view",
	WIRETRANSFER_HKDINFO_VIEW = "wiretransfer_hkdinfo_view",
	WIRETRANSLFER_SGDCLICK_RECEIPTS = "wiretranslfer_sgdclick_receipts",
	WIRETRANSFER_CLICK_TRANSFEREED = "wiretransfer_click_transfereed",
	WIRETRANSFER_NOTIFY_VIEW = "wiretransfer_notify_view",
	WIRETRANSFER_CLICK_NOTIFY = "wiretransfer_click_notify",
	WIRETRANSFER_NOTIFICATION_RECEIVED = "wiretransfer_notification_received",

	// 入金选币页 - 大陆用户拦截
	DEPOSIT_CURRENCY_MAINLAND_BLOCKED_VIEW = "deposit_currency_mainland_blocked_view", // 入金选币页_大陆用户拦截弹窗_曝光
	DEPOSIT_CURRENCY_MAINLAND_BLOCKED_CONFIRM = "deposit_currency_mainland_blocked_confirm", // 入金选币页_大陆用户拦截弹窗_确认

	// 运营活动 -- 新入金
	referral_homepage_pageview = "referral_homepage_pageview", //浏览事件-页面打开
	referral_homepage_copycode = "referral_homepage_copycode", // 复制邀请码
	referral_homepage_sharelink = "referral_homepage_sharelink", // 分享邀请链接
	referral_homepage_click_myreward = "referral_homepage_click_myreward", // referral_homepage_click_myreward
	referral_homepage_click_myinvite = "referral_homepage_click_myinvite", // referral_homepage_click_myinvite

	// 运营活动 -- 免佣金
	zero_commission_activity_is_zero_commission = "zero_commission_activity_is_zero_commission", // 是否免佣金
	zero_commission_activity_is_open_account = "zero_commission_activity_is_open_account", // 是否开户
	zero_commission_activity_is_deposit = "zero_commission_activity_is_deposit", // 是否入金

	// 绑定注册
	bind_register_h5 = "login_userRegister", // 注册成功

	// 上报渠道
	login_userSource = "login_userSource",

	// googe recaptcha
	login_google_recaptcha_show = "login_google_recaptcha_show",
	login_google_recaptcha_success = "login_google_recaptcha_success",
	login_google_recaptcha_error = "login_google_recaptcha_error",

	// ali captcha
	ali_captcha_initial_success = "ali_captcha_initial_success",
	ali_captcha_initial_error = "ali_captcha_initial_error",
	ali_captcha_verify_success = "ali_captcha_verify_success",
	ali_captcha_verify_error = "ali_captcha_verify_error",

	// 登录/注册验证码
	start_request_code = "start_request_code", // 请求验证码 开始
	response_request_code = "response_request_code", // 请求验证码 响应
	start_request_verify_code = "start_request_verify_code", // 校验证件以及验证码 开始
	response_verify_code = "response_verify_code", // 校验证件以及验证码 响应
	login_discernCode = "login_discernCode", // 验证验证码结果

	// 投教ICON AB 测试
	click_teach_introduce = "click_teach_introduce",

	// 运营活动--hot
	hot_activity_ai_application_navigation_share = "hot_activity_ai_application_navigation_share", // AI应用
	hot_activity_ai_application_voted_click = "hot_activity_ai_application_voted_click",
	hot_activity_ai_application_deeplink = "hot_activity_ai_application_deeplink",

	// 运营活动--btw
	hot_activity_btw_application_navigation_share = "hot_activity_btw_application_navigation_share", // AI应用
	hot_activity_btw_application_voted_click = "hot_activity_btw_application_voted_click",
	hot_activity_btw_application_deeplink = "hot_activity_btw_application_deeplink",
	hot_activity_btw_application_tradeNow = "hot_activity_btw_application_tradeNow",

	// 2024 年报
	summary_2024_page = "summary_2024_page",
	summary_2025_page = "summary_2025_page",

	// 股单分享落地页
	investing_watchlist = "investing_watchlist",

	// 自动跟单活动
	activities_auto_copy_click = "activities_auto_copy_click",
	activities_auto_copy_share = "activities_auto_copy_share",

	// 自动跟单收益
	auto_copy_profit_modal_show = "auto_copy_profit_modal_show",
	auto_copy_record_profit_share_click = "auto_copy_record_profit_share_click",

	// App Flyer
	appsflyer_onelink = "appsflyer_onelink",

	// 产品体验
	product_experience_survey = "product_experience_survey", // 产品体验
	product_experience_submit_modal = "product_experience_submit_modal", // 产品体验提交

	// ai策略
	ai_portfolio_h5List_card_click = "ai_portfolio_h5List_card_click", // ai策略列表卡片点击

	// 跳过验证码
	survey_deposit_jump_bind_phone = "survey_deposit_jump_bind_phone",

	// 跳过绑定手机号
	da_investorSurvey_skipPhoneVerificationButton_click = "da_investorSurvey_skipPhoneVerificationButton_click",

	// bobby 下单免佣活动
	da_bobbycommissionActivityPage_signUpBtn_click = "da_bobbycommissionActivityPage_signUpBtn_click", // 报名按钮点击
	da_bobbycommissionActivityPage_bobbyBtn_click = "da_bobbycommissionActivityPage_bobbyBtn_click", // 打开 Bobby 按钮点击

	// 策略服务
	strategy_service_apply_submit = "strategy_service_apply_submit",
	strategy_service_reapply_click = "strategy_service_reapply_click",
	strategy_service_plan_create_profit_tip = "strategy_service_plan_create_profit_tip",
	strategy_service_rule_click = "strategy_service_rule_click",

	// 港股打新
	ipo_subscription_click_contactcustserv = "click_contactcustserv",
	ipo_subscription_click_noted = "click_noted",
	ipo_grey_node_click = "ipo_grey_node_click",
	ipo_grey_popup_view = "ipo_grey_popup_view",
	ipo_grey_popup_cta_click = "ipo_grey_popup_cta_click",

	// 跟单相关
	autocopy_order_submit = "autocopy_order_submit", // 跟单订单提交
	watchlist_order_submit = "watchlist_order_submit", // 股单跟单

	// 期权知识学习（投教答题）
	learning_intro_view = "learning_intro_view", // 学习引导出现
	learning_started = "learning_started", // 用户接受学习
	question_correct = "question_correct", // 单题答对
	question_incorrect = "question_incorrect", // 单题答错
	question_explanation_view = "question_explanation_view", // 用户查看讲解
	learning_abandoned = "learning_abandoned", // 用户中途退出
	learning_completed = "learning_completed", // 段完成
	// 出金
	withdraw_enter_continue = "withdraw_enter_continue", // 出金入口_继续
	withdraw_amount_pv = "withdraw_amount_pv", // 出金金额页_可取金额曝光
	withdraw_amount_continue = "withdraw_amount_continue", // 出金金额页_继续
	withdraw_amount_continue_block = "withdraw_amount_continue_block", // 出金金额页_继续被拦截
	withdraw_order_assets_fail = "withdraw_order_assets_fail", // 出金提交_资产刷新失败
	withdraw_order_submit = "withdraw_order_submit", // 出金_提交建单
	withdraw_order_insufficient = "withdraw_order_insufficient", // 出金_提交时可用资金不足
	withdraw_order_insufficient_confirm = "withdraw_order_insufficient_confirm", // 出金_不足弹层确认返回
}

interface SensorsParams {
	[index: string]: any;
}

interface NewDepositCommonParams extends SensorsParams {
	inviter_code?: string; //字符串，页面显示邀请码
	is_deposit?: string; // 0=当前用户未入金，1=当前用户已入金
	invite_reg_num?: number; // 当前已邀请注册人数（同页面展示）
	invite_open_num?: number; //当前已邀请开户人数（同页面展示）
	invite_deposit_num?: number; // 当前已完成任务人数（同页面展示,如果只能看2个以内或以上也可以只赋值0,1,2）
}

/**
 * 神策埋点
 * @param {SensorsEventIds} [eventId]
 * @param {SensorsParams} [params]
 */
export default function log2sensors(eventId: SensorsEventIds | string, params?: SensorsParams) {
	if (typeof window === "undefined") return;
	if (!window.sensorsDataAnalytic201505) return;

	let pa: SensorsParams = {};
	if (params) {
		pa = { ...params };
	}

	if (rfStore.getRFState()) {
		pa["userId"] = rfStore.getRFState()?.userId;
	}

	window.sensorsDataAnalytic201505.track(eventId, { ...pa });
}

/**
 * 设置登录属性
 */
export function sensorsLogin(userId: string) {
	if (typeof window === "undefined") return;
	if (!window.sensorsDataAnalytic201505) return;

	window.sensorsDataAnalytic201505.login(userId);
}

/**
 * 设置公共参数
 */
export function sensorSettingPublicProperties(params: { [index: string]: any }) {
	if (typeof window === "undefined") return;
	if (!window.sensorsDataAnalytic201505) return;

	window.sensorsDataAnalytic201505.setProfile({
		...params,
	});
}

/**
 * @summary 新神策打点
 */
export const GenZSensorEvents = {
	da_wyhdyh_pv: {
		event: "da_wyhdyh_pv",
		description: "DA_五一活动首页所有用户_页面浏览",
	},
	da_wyhdwzcyh_pv: {
		event: "da_wyhdwzcyh_pv",
		description: "DA_五一活动首页未注册用户数_页面浏览",
	},
	da_wyhdsjzfan_click: {
		event: "da_wyhdsjzfan_click",
		description: "DA_五一活动首页转发按钮_点击",
	},
	da_wyhdgwmj_click: {
		event: "da_wyhdgwmj_click",
		description: "DA_五一活动首页梗王秘籍_点击",
	},
	da_wyhdphb_pv: {
		event: "da_wyhdphb_pv",
		description: "DA_五一活动首页梗王秘籍_排行榜_页面浏览",
	},
	da_wyhdzdphb_pv: {
		event: "da_wyhdzdphb_pv",
		description: "DA_五一活动首页梗王秘籍战队排行榜_页面浏览",
	},
	da_wyhdmyreward_pv: {
		event: "da_wyhdmyreward_pv",
		description: "DA_五一活动首页梗王秘籍我的奖励_页面浏览",
	},
	da_wyhddty_staytime: {
		event: "da_wyhddty_staytime",
		description: "DA_五一活动答题页_停留时间",
	},
	da_wyhddty_zqxx_click: {
		event: "da_wyhddty_zqxx_click",
		description: "DA_五一活动答题页_点击选项按钮_正确选项_点击",
	},
	da_wyhddty_zfan_click: {
		event: "da_wyhddty_zfan_click",
		description: "DA_五一活动答题页_转发按钮_点击",
	},
	da_wyhdcgy_ckpm_pv: {
		event: "da_wyhdcgy_ckpm_pv",
		description: "DA_五一活动答题成功页_查看排名_页面浏览",
	},
	da_wyhdcgy_ckzdpm_pv: {
		event: "da_wyhdcgy_ckzdpm_pv",
		description: "DA_五一活动答题成功页_查看战队排名_页面浏览",
	},
	da_wyhdcgy_zctzan_click: {
		event: "da_wyhdcgy_zctzan_click",
		description: "DA_五一活动答题成功页_再次挑战按钮_点击",
	},
	da_wyhdcgy_fxan_click: {
		event: "da_wyhdcgy_fxan_click",
		description: "DA_五一活动答题成功页_分享按钮_点击",
	},
};

// scene
export enum SensorsVerifyCodeScene {
	login = "login",
	bind_phone_number = "bind_phone_number",
	bind_email = "bind_email",
}
